import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"
import { normalizeMetricGoals } from "../../lib/utils/metricGoals"
import { skipIfCatalogLoaded } from "../utils/fetchDedupe"

/**
 * GET /api/v1/metric-goals
 * Returns selectable goal metrics (visibility, engagement, growth).
 */
export const fetchMetricGoals = createAsyncThunk(
  "metricGoals/fetch",
  async (_arg, { rejectWithValue }) => {
    try {
      const data = await get("metric-goals")
      return normalizeMetricGoals(data)
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch metric goals")
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force) return true
      return !skipIfCatalogLoaded(getState().metricGoals)
    },
  },
)

const initialState = {
  goals: [],
  status: "idle",
  error: null,
}

const metricGoalsSlice = createSlice({
  name: "metricGoals",
  initialState,
  reducers: {
    clearMetricGoals: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMetricGoals.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchMetricGoals.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.goals = action.payload ?? []
      })
      .addCase(fetchMetricGoals.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch metric goals"
      })
  },
})

export const { clearMetricGoals } = metricGoalsSlice.actions
export default metricGoalsSlice.reducer
